import type { User } from '@/api/user';
import { useCurrentUser } from '@/api/user';

/**
 * Returns the current user, or undefined while loading / when unauthenticated.
 * Backed by the `useCurrentUser` TanStack query (was a Remix root-loader lookup
 * via `useMatchesData('root')`).
 */
export function useOptionalUser(): User | undefined {
    const { data } = useCurrentUser();
    return data ?? undefined;
}
